'use strict';

var React = require('react');

/** This hook allows quickly find option by it value */
function useOptionsMap(options) {
    const optionsMap = React.useMemo(() => {
        if (!options) {
            return {};
        }
        return options.reduce((acc, o) => {
            acc[o.value] = o;
            return acc;
        }, {});
    }, [options]);
    const getOptionByValue = React.useCallback((value) => optionsMap[value] || {}, [optionsMap]);
    return getOptionByValue;
}

exports.useOptionsMap = useOptionsMap;
//# sourceMappingURL=useOptionsMap.js.map
